module.exports = __webpack_public_path__ + "static/image/weChat_taizhou.4eaab9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weChat_taizhou.jpg
// module id = 381
// module chunks = 1